import { render } from "./GroupedTable.vue?vue&type=template&id=661658b4"
import script from "./GroupedTable.vue?vue&type=script&lang=js"
export * from "./GroupedTable.vue?vue&type=script&lang=js"

import "./GroupedTable.vue?vue&type=style&index=0&id=661658b4&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__